export default "__VITE_ASSET___d4LFIOr__"